module.exports = __webpack_public_path__ + "img/nogo-stack-test-min.e3886fc5.jpg";